import React, { useCallback, useEffect, useRef } from "react";

const CustomInputProps = React.memo(
  ({
    value = "",
    onChange,
    placeholder,
    countryCode,
    isCurrencyInput = false,
    error = "",
    iconDropdown = true,
    classNameInput,
    readOnly = false,
    icon,
    classWrapper = "",
    showIcon = true,
  }) => {
    const inputRef = useRef(null);
    const hasFocused = useRef(false);
    const formatInput = useCallback(
      (input) => {
        if (isCurrencyInput) {
          const cleaned = input.replace(/[^0-9.]/g, "");
          return cleaned;
        } else {
          const cleaned = input.replace(/[^0-9]/g, "");
          return cleaned;
        }
      },
      [isCurrencyInput]
    );

    const handleInputChange = useCallback(
      (e) => {
        const formattedInput = formatInput(e.target.value);
        onChange(formattedInput);
      },
      [onChange, formatInput]
    );

    useEffect(() => {
      if (readOnly) return; // nếu readonly → không focus
      if (hasFocused.current) return; // chỉ focus lần đầu
      if (!inputRef.current) return;

      // Delay cực nhỏ để Framer Motion hoàn thành mount trước
      const timer = setTimeout(() => {
        inputRef.current?.focus();
        hasFocused.current = true;
      }, 150); // 100–200ms là đủ để animation mượt

      return () => clearTimeout(timer);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <div
        className={`flex h-[50px] items-center bg-white rounded-lg px-3 py-2 border ${
          error
            ? "border-destructive focus-within:border-destructive"
            : "border-mid-gray focus-within:border-mid-gray"
        }  focus-within:border-1 transition-colors duration-200`}
      >
        <div
          className={`flex gap-[6px] w-auto h-6 items-center border-r pr-1.5 ${classWrapper}`}
        >
          {showIcon && (
            <div className="size-6 flex justify-center items-center">
              {icon ? (
                icon
              ) : (
                <span className="icon icon-whatsapp text-[#06C755] text-xl" />
              )}
            </div>
          )}

          {countryCode && (
            <div className="text-mid-gray font-medium text-sm leading-6">
              {countryCode}
            </div>
          )}
          {iconDropdown && (
            <div className="size-3 flex justify-center items-center">
              <span className="icon icon-unfold-more text-mid-gray text-[10px]" />
            </div>
          )}
        </div>
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={handleInputChange}
          className={`outline-none w-full bg-transparent text-base placeholder:text-mid-gray ml-2 focus:outline-none ${
            classNameInput || "text-dark-gray"
          }`}
          placeholder={placeholder || ""}
          readOnly={readOnly}
        />
      </div>
    );
  }
);

export default CustomInputProps;
